import { Button, Form, Input, Modal, Select } from "antd";
import { useEffect, useState } from "react";
import { DoEkoPay, getEkoPayBanks } from "../EkoEndpoint";
import CommonInput from "../../../../Common/CommonInput";
import { dispatchtoast, filterOption, getLocalStorageItem, ifscPattern, pincodePattern } from "../../../../Utils";
import { getPayoutAndDmtOtp } from "../../../../ApiServices/Apifun";
import { useDispatch } from "react-redux";
import { setselectedTab } from "../../../../Store/B2bslice";

const EkoPayout = () => {
    const [form] = Form.useForm();
    const dispatch = useDispatch()
    const [btnLoading, setBtnLoading] = useState(false);
    const [openOtpModal, setOpenOtpModal] = useState(false)
    const [otpUid, setOtpUid] = useState(null)
    const [otp, setOtp] = useState(null)
    const [filledDetails, setFilledDetails] = useState(null)
    const [paybanks, setpaybanks] = useState([]);
    const handleGetbank = () => {
        getEkoPayBanks()
            .then((res) => {
                setpaybanks(
                    res.data.banks.map((i) => {
                        return {
                            label: (
                                <p
                                    onClick={() => {
                                        form.setFieldsValue({
                                            benificiary_bank_name: i?.bank_name,
                                            benificiary_account: i?.account_no,
                                            benificiary_ifsc: i?.ifsc_code,
                                            benificiary_name: i?.account_holder,
                                        });
                                    }}
                                >
                                    {i?.bank_name}
                                </p>
                            ),
                            value: i?.bank_name,
                        };
                    })
                );
            })
            .catch((err) => console.log(err));
    };

    useEffect(() => {
        handleGetbank();
        dispatch(setselectedTab("300.2"))
    }, []);

    const handlePay = (v) => {
        setFilledDetails(v)
        setBtnLoading(true)
        getPayoutAndDmtOtp().then(res => {
            if (res.status) {
                setOpenOtpModal(true)
                setOtpUid(res.otp_uid)
            }
        }).catch(err => console.log(err)).finally(() => setBtnLoading(false))
    }

    const handleVerify = () => {
        setBtnLoading(true)
        const formdata = new FormData()
        formdata.append("latitude", getLocalStorageItem("latitude"))
        formdata.append("otp_uid", otpUid)
        formdata.append("otp", otp)
        formdata.append("longitude", getLocalStorageItem("longitude"))
        Object.keys(filledDetails).map(i => formdata.append(i, filledDetails[i]))
        DoEkoPay(formdata).then(res => {
            if (res.status) {
                dispatchtoast(res.message)
            }
        }).catch(err => console.log(err)).finally(() => {
            setBtnLoading(false)
            form.resetFields()
            setOpenOtpModal(false)
        })

    }
    return (
        <>
            <div className="grid grid-cols-1 md:grid-cols-1 place-items-start">
                <div className="prepaid animate-slide-in w-full md:w-1/2 bg-white shadow-normal  rounded-3xl p-5">
                    <p className="font-bold text-[15px] mb-2"> Payments</p>
                    <Form
                        name="form"
                        form={form}
                        onFinishFailed={(err) => console.log(err)}
                        onFinish={(val) => handlePay(val)}
                    >
                        <Form.Item
                            name={`benificiary_bank_name`}
                            label={"Select Bank"}
                            labelCol={{ span: 24 }}
                            rules={[
                                {
                                    required: true,
                                    message: "Select One Bank!",
                                },
                            ]}
                        >
                            <Select
                                placeholder="Select a bank"
                                className="w-full mt-2"
                                options={paybanks}
                            />
                        </Form.Item>
                        <Form.Item
                            name={`benificiary_ifsc`}
                            label={"IFSC"}
                            labelCol={{ span: 24 }}
                            rules={[
                                {
                                    required: true,
                                    message: "Enter IFSC!",
                                },
                                {
                                    pattern: ifscPattern,
                                    message: "Enter valid IFSC!",
                                },
                                {
                                    whitespace: true,
                                    message: "Field cannot contain only blank spaces",
                                },
                            ]}
                        >
                            <CommonInput
                                disabled
                                onInput={(e) => {
                                    const value = e.target.value.toUpperCase();
                                    e.target.value = value;
                                }}
                                placeholder="Enter IFSC"
                                name="benificiary_ifsc"
                            />
                        </Form.Item>{" "}
                        <Form.Item
                            name={`benificiary_account`}
                            label={"Account No."}
                            labelCol={{ span: 24 }}
                            rules={[
                                {
                                    required: true,
                                    message: "Enter account no!",
                                },
                                {
                                    whitespace: true,
                                    message: "Field cannot contain only blank spaces",
                                },
                            ]}
                        >
                            <CommonInput
                                disabled
                                onInput={(e) => {
                                    const value = e.target.value.replace(/\D/g, "");
                                    e.target.value = value;
                                }}
                                placeholder="Enter account No"
                                name="amount"
                            />
                        </Form.Item>
                        <Form.Item
                            name={`benificiary_name`}
                            label={"Benificiary Name"}
                            labelCol={{ span: 24 }}
                            rules={[
                                {
                                    required: true,
                                    message: "Enter Benificiary Name!",
                                },
                                {
                                    whitespace: true,
                                    message: "Field cannot contain only blank spaces",
                                },
                            ]}
                        >
                            <CommonInput
                                disabled
                                placeholder="Enter Benificiary Name"
                                name="benificiary_name"
                            />
                        </Form.Item>{" "}
                        <Form.Item
                            name={`amount`}
                            label={"Amount"}
                            labelCol={{ span: 24 }}
                            rules={[
                                {
                                    required: true,
                                    message: "Enter Amount!",
                                },
                                {
                                    whitespace: true,
                                    message: "Field cannot contain only blank spaces",
                                },
                            ]}
                        >
                            <CommonInput
                                onInput={(e) => {
                                    const value = e.target.value.replace(/\D/g, "");
                                    e.target.value = value;
                                }}
                                placeholder="Enter Amount"
                                name="amount"
                            />
                        </Form.Item>
                        <Form.Item
                            name={`pin_code`}
                            label={"Pin Code"}
                            labelCol={{ span: 24 }}
                            rules={[
                                {
                                    required: true,
                                    message: "Enter Pin Code!",
                                },
                                {
                                    pattern: pincodePattern,
                                    message: "Enter valid pin code!",
                                },
                                {
                                    whitespace: true,
                                    message: "Field cannot contain only blank spaces",
                                },
                            ]}
                        >
                            <CommonInput placeholder="Enter Pin Code" />
                        </Form.Item>{" "}
                        <Form.Item
                            name={`account_type`}
                            label={"Select Account Type"}
                            labelCol={{ span: 24 }}
                            rules={[
                                {
                                    required: true,
                                    message: "Select Account type!",
                                },
                            ]}
                        >
                            <Select
                                showSearch
                                placeholder="Select account type"
                                filterOption={filterOption}
                                className="w-full mt-2"
                                options={[
                                    { label: "Saving Account", value: 2 },
                                    { label: "Current Account", value: 1 },
                                ]}
                            />
                        </Form.Item>
                        {/* )} */}
                        <Button
                            loading={btnLoading}
                            className="w-full bg-primary border-none mt-4"
                            style={{ color: "white" }}
                            htmlType="submit"
                        >
                            Pay
                        </Button>
                    </Form>
                </div>
            </div>
            {openOtpModal && <Modal
                title={"Verify OTP"}
                footer={null}
                className="shadow-normal"
                width={300}
                maskClosable={false}
                open={openOtpModal}
                onCancel={() => setOpenOtpModal(false)}
            >
                <div className="  rounded-3xl shadow-normal bg-white ">
                    <Form onFinish={(v) => handleVerify(v)} labelCol={{ span: 24 }}>
                        <Form.Item name={"otp"} label="otp" rules={[{
                            required: true,
                            message: "Enter otp"
                        }]}>
                            <div className=" mt-5 flex justify-center items-center">
                                <Input.OTP onChange={v => setOtp(v)} />
                            </div>
                        </Form.Item>
                        <Button
                            type="primary"
                            htmlType="submit"
                            loading={btnLoading}
                            className={`SignInBtn w-full flex justify-center border-none items-center h-12 mt-4  rounded-full text-white text-[12px] font-bold`}
                        >
                            <p>Verify OTP</p>
                        </Button>
                    </Form>

                </div>
            </Modal>}
        </>
    );
};

export default EkoPayout;
